import * as Yup from 'yup'
import isValidAbn from 'is-valid-abn'

export const validationSchema = (t) =>
  Yup.object().shape({
    name: Yup.string().required(
      t('pointsOnPayments:updatePayeeModal.fields.name.requiredError'),
    ),
    email: Yup.string()
      .required(t('pointsOnPayments:updatePayeeModal.fields.email.requiredError'))
      .email(t('pointsOnPayments:updatePayeeModal.fields.email.invalidError')),
    businessNumber: Yup.string().test(
      'validAbn',
      t('pointsOnPayments:updatePayeeModal.fields.businessNumber.invalidError'),
      (value) => !value || isValidAbn(value),
    ),
    bankAccount: Yup.object().shape({
      name: Yup.string().required(
        t(
          'pointsOnPayments:updatePayeeModal.fields.bankAccountName.requiredError',
        ),
      ),
      bsb: Yup.string()
        .matches(
          /^\d{6}$/,
          t('pointsOnPayments:updatePayeeModal.fields.branchCode.lengthError'),
        )
        .required(
          t(
            'pointsOnPayments:updatePayeeModal.fields.branchCode.requiredError',
          ),
        ),
      accountNumber: Yup.string()
        .matches(
          /^\d{6,9}$/,
          t(
            'pointsOnPayments:updatePayeeModal.fields.accountNumber.lengthError',
          ),
        )
        .required(
          t(
            'pointsOnPayments:updatePayeeModal.fields.accountNumber.requiredError',
          ),
        ),
    }),
  })
